export type VCButtons = {
    NONE: number;
    UP: number;
    DOWN: number;
    LEFT: number;
    RIGHT: number;
    A: number;
    B: number;
    X: number;
    Y: number;
    START: number;
    SELECT: number;
}

export type VCStatus = {
    NONE: number,
    CLICK: number,
    HOLD: number,
    RELEASE: number
};

export enum padButtons {
    NONE = -1,
    UP = 0,
    DOWN = 1,
    LEFT = 2,
    RIGHT = 3,
    A = 4,
    B = 5,
    X = 6,
    Y = 7,
    START = 8,
    SELECT = 9
}

export enum padStates {
    NONE = -1,
    CLICK = 1,
    HOLD = 2,
    RELEASE = 3
}

export class VirtualControlPad {
    _buttons: VCButtons;
    _status: VCStatus;
    _buttonStatus: VCButtons;
    _buttonHeldFor: VCButtons;
    _lastButtonPressed: number;
  usingGamepad: boolean;
  DPadActive: boolean;

    constructor(){
    
        this._buttons = padButtons;
        this._status = padStates;
        this.reset();

    }

    reset(){
        
        this._buttonStatus = {
            NONE: this._status.NONE,
            UP : this._status.NONE,
            DOWN : this._status.NONE,
            LEFT: this._status.NONE,
            RIGHT: this._status.NONE,
            A: this._status.NONE,
            B: this._status.NONE,
            X: this._status.NONE,
            Y: this._status.NONE,
            START: this._status.NONE,
            SELECT: this._status.NONE
        };
        
        this._buttonHeldFor = {
            NONE: 0,
            UP : 0,
            DOWN : 0,
            LEFT: 0,
            RIGHT: 0,
            A: 0,
            B: 0,
            X: 0,
            Y: 0,
            START: 0,
            SELECT: 0
        };
 
        this._lastButtonPressed = this._buttons.NONE;  
    }

    isClicked(id: number){ //id should be from this._buttons
        return (this._buttonStatus[id] == this._status.CLICK );
    }

    isHeld(id: number){ //id should be from this._buttons
        return (this._buttonStatus[id] == this._status.HOLD );
    }

    isHeldFor(id: number,time: number){ //id should be from this._buttons
        return (this._buttonHeldFor[id] > time);
    }

    resetHeldFor(id: number){
        this._buttonHeldFor[id] = 0;
    }

    isClickedOrHeld(id: number){ //id should be from this._buttons
        return (this._buttonStatus[id] == this._status.HOLD || this._buttonStatus[id] == this._status.CLICK );
    }

    isClickedOrHeldFor(id: number,time: number){ //id should be from this._buttons
        return ( (this._buttonStatus[id] == this._status.HOLD && this._buttonHeldFor[id] > time ) || this._buttonStatus[id] == this._status.CLICK );
    }

    isReleased(id: number){ //id should be from this._buttons
        return (this._buttonStatus[id] == this._status.RELEASE );
    }

    isNone(id: number){ //id should be from this._buttons
        return (this._buttonStatus[id] == this._status.NONE );
    }

    setStatus(id: number, stat: number){
        this._buttonStatus[id] = stat;
    }


    onUpdate(timeMS: number){
        for(const skey in this._buttonStatus){
            if(this._buttonStatus[skey] == this._status.HOLD ){
                this._buttonHeldFor[skey] += timeMS;
            }
            if(this._buttonStatus[skey] == this._status.CLICK ){
                this._buttonStatus[skey] = this._status.HOLD;

            }
            if(this._buttonStatus[skey] == this._status.RELEASE ){
                this.resetHeldFor(parseInt(skey));
                this._buttonStatus[skey] = this._status.NONE;
            }
        }
    }

}

export default new VirtualControlPad();